import MenuError from 'components/corporatiu/MenuError';
import NotFound from 'components/corporatiu/NotFound';

const Error = (props) => {
    const { statusCode } = props;

    return (
        <div style={{ backgroundColor: '#111' }}>
            <MenuError />
            <NotFound code={statusCode} text={statusCode === 404 ? 'Pàgina no trobada' : 'Error a la pàgina'} />
        </div>
    );
};

export default Error;
